import React from 'react';
import PropTypes from 'prop-types';
import AboutUsPanel from './AboutUsPanel';
import GetInTouchPanel from './GetInTouchPanel';
import OurFoodPanel from './OurFoodPanel';
import RestaurantPanel from './RestaurantPanel';
import {Wrapper, Container} from './HomePage.style';
import FacebookLike from '../../components/FacebookLike/FacebookLike';
import TradeShowButton from '../../components/TradeShowButton/TradeShowButton';
import FSArating from '../../components/FSArating/FSArating';

const HomePageContent = ({
    googleMapUrl,
    headerColor,
    isOpen,
    isOpenForCollectionOrDelivery,
    isOpensInSevenDays,
    isOrderAvailable,
    openButtonText,
    openingTimesContent,
    orderNowButtonText,
    preferences,
    restaurant,
    thirdPartyServices
}) => {
  const renderFacebookLikeButton = thirdPartyServices && thirdPartyServices.facebookPageUrl &&
    FacebookLike({
      pageContext: 'homePage',
      url: restaurant.thirdPartyServices.facebookPageUrl
    });

  const renderTradeShowButton =
    TradeShowButton({
      url: '/menu',
      headerColor,
      orderNowButtonText
    });

  const renderRestaurantPanel = preferences.restaurantPanel && (
    <RestaurantPanel
      googleMapUrl={googleMapUrl}
      headerColor={headerColor}
      isOpen={isOpen}
      isOpenForCollectionOrDelivery={isOpenForCollectionOrDelivery}
      isOpensInSevenDays={isOpensInSevenDays}
      openButtonText={openButtonText}
      openingTimesContent={openingTimesContent}
      renderTradeShowButton={renderTradeShowButton}
      restaurant={restaurant}
    />
  );

  const renderOurFoodPanel = preferences.ourFood && restaurant.content.ourFood &&
    OurFoodPanel({
      content: restaurant.content,
      headerColor,
      openButtonText,
      renderTradeShowButton
    });

  const renderAboutUsPanel = preferences.aboutUs.show &&
    AboutUsPanel({
      headerColor,
      orderNowButtonText,
      preferences: preferences.aboutUs.content,
      renderTradeShowButton,
      restaurant
    });

  const renderGetInTouchPanel = preferences.getInTouch &&
    GetInTouchPanel({
      headerColor,
      isOrderAvailable,
      renderTradeShowButton,
      restaurant
    });

  return (
    <Wrapper data-rw="home-page--content">
      {renderRestaurantPanel}
      <Container>
        {renderOurFoodPanel}
        {renderAboutUsPanel}
        {renderGetInTouchPanel}
        {renderFacebookLikeButton}
        <FSArating restaurant={restaurant} />
      </Container>
    </Wrapper>
  );
};

HomePageContent.propTypes = {
  googleMapUrl: PropTypes.string,
  headerColor: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isOpenForCollectionOrDelivery: PropTypes.bool.isRequired,
  isOpensInSevenDays: PropTypes.bool.isRequired,
  isOrderAvailable: PropTypes.bool.isRequired,
  openButtonText: PropTypes.string.isRequired,
  openingTimesContent: PropTypes.object,
  orderNowButtonText: PropTypes.string.isRequired,
  preferences: PropTypes.object.isRequired,
  restaurant: PropTypes.object.isRequired,
  thirdPartyServices: PropTypes.object
};

export default HomePageContent;



// WEBPACK FOOTER //
// ./containers/HomePage/HomePageContent.js